import { useInfiniteQuery } from '@tanstack/react-query';
import { get } from '../api/api';
import { API_URLS } from '../constants/apiUrl';
import { QueryParamObject, toQueryString } from '../constants/utilityFunctions';
interface IUseFetchWorkTime {
  startTime?: string;
  dueTime?: string;
  relations?: string[];
  sortBy?: string[];
  extraFilters?: Record<string, string | number | undefined>;
  pageSize?: number;
  search?: string;
  fields?: string[];
}
export const useFetchWorkTimeList = (params: IUseFetchWorkTime) => {
  const fetchWorkTimes = async ({ pageParam = 1 }) => {
    const { relations: workTimeRelations, extraFilters: filters, pageSize, ...rest } = params;
    const queryString = new URLSearchParams(
      Object.keys(rest)?.length ? toQueryString(rest as QueryParamObject) : '',
    );

    Object.entries(filters ?? {}).forEach(([key, value]) => {
      if (value) {
        queryString.append(`filter.${key}`, String(value));
      }
    });

    (workTimeRelations ?? []).forEach((rel) => queryString.append('relations', rel));

    queryString.append('page', String(pageParam));
    queryString.append('limit', String(pageSize));
    try {
      return await get(`${API_URLS.WORK_TIMES}?${queryString.toString()}`);
    } catch (error) {
      console.error('Error fetching worktime:', error);
      throw new Error((error as { message: string }).message || 'Failed to fetch worktime'); // Force error throwing
    }
  };

  const {
    data,
    isLoading,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isFetchNextPageError,
    refetch,
    isFetching,
  } = useInfiniteQuery({
    initialPageParam: 1,
    queryKey: ['worktime-list', params],
    queryFn: fetchWorkTimes,
    getNextPageParam: (lastPage, allPages) => {
      const totalCount = lastPage?.meta?.totalItems ?? 0;
      const fetchedCount = allPages.flatMap((page) => page.data).length;
      return fetchedCount < totalCount ? allPages.length + 1 : undefined;
    },
  });
  return {
    data: data?.pages.flatMap((page) => page.data) ?? [],
    isLoading,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isFetchNextPageError,
    refetch,
    isFetching,
  };
};
